import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ValidationErrorContextType {
  validationError: string | null;
  setValidationError: (error: string | null) => void;
  clearValidationError: () => void;
}

const ValidationErrorContext = createContext<ValidationErrorContextType | undefined>(undefined);

export const useValidationError = () => {
  const context = useContext(ValidationErrorContext);
  if (context === undefined) {
    throw new Error('useValidationError must be used within a ValidationErrorProvider');
  }
  return context;
};

interface ValidationErrorProviderProps {
  children: ReactNode;
}

export const ValidationErrorProvider: React.FC<ValidationErrorProviderProps> = ({ children }) => {
  const [validationError, setValidationError] = useState<string | null>(null);

  const clearValidationError = () => {
    setValidationError(null);
  };

  return (
    <ValidationErrorContext.Provider value={{
      validationError,
      setValidationError,
      clearValidationError,
    }}>
      {children}
    </ValidationErrorContext.Provider>
  );
}; 